module.exports = __webpack_public_path__ + "static/img/The-Imperial.feae4e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/The-Imperial.jpg
// module id = xYyT
// module chunks = 0